import { ActivatedRoute, ActivatedRouteSnapshot } from "@angular/router";
import { flatten, merge } from "lodash-es";
import { ActivatedRouteParamsResolutionError } from "src/app/errors/activated-route-params-resolution.error";

export function routeParam(
  activatedRoute: ActivatedRoute,
  param: string
): string {
  return activatedRoute.snapshot.params[param];
}

export function activatedRouteSnapshotGetPathFromRoot(
  snapshot: ActivatedRouteSnapshot
): string {
  return `/${flatten(snapshot.pathFromRoot.map((snapshot) => snapshot.url))
    .map((x) => x.toString())
    .join("/")}`;
}

export function getActivatedRouteMergedParams(
  snapshot: ActivatedRouteSnapshot,
  params: Record<string, string> = {}
): Record<string, string> {
  if (!snapshot.parent && !!snapshot.firstChild) {
    return getActivatedRouteMergedParamsFromRootToLastChild(snapshot, params);
  }

  if (snapshot.parent && !snapshot.firstChild) {
    return getActivatedRouteMergedParamsFromLastChildToParent(snapshot, params);
  }

  throw new ActivatedRouteParamsResolutionError(snapshot);
}

export function getActivatedRouteMergedParamsFromRootToLastChild(
  snapshot: ActivatedRouteSnapshot,
  params: Record<string, string> = {}
): Record<string, string> {
  merge(params, snapshot.params);

  if (snapshot.firstChild) {
    getActivatedRouteMergedParamsFromRootToLastChild(
      snapshot.firstChild,
      params
    );
  }

  return params;
}

export function getActivatedRouteMergedParamsFromLastChildToParent(
  snapshot: ActivatedRouteSnapshot,
  params: Record<string, string> = {}
): Record<string, string> {
  merge(params, snapshot.params);

  if (snapshot.firstChild) {
    getActivatedRouteMergedParamsFromRootToLastChild(
      snapshot.firstChild,
      params
    );
  }

  return params;
}
